import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { ACTIVE_SCHEMA_FIELDS, PAGINATED_SCHEMA_FIELDS } from '../basics';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/** Form schema for the DebitCardLoyaltyStatusHistory component settings in the designer. */
export const DEBIT_CARD_LOYALTY_STATUS_HISTORY_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [...ACTIVE_SCHEMA_FIELDS, ...BASIC_SCHEMA_FIELDS, ...SPACING_SCHEMA, ...PAGINATED_SCHEMA_FIELDS]
};
